export default __webpack_public_path__ + "static/media/step2.7f173f01.svg";